import { UserFullInfo, UserMan } from "../types/user";

export const getPlanName = (user: UserFullInfo | UserMan) => {
  if (user.isPaidSubscriber) {
    return "basic";
  }
  if (user.isStandardPlanUser) {
    return "standard";
  }
  if (user.isPremiumUser) {
    return "premium";
  }
  return "free";
};
